import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-58a8f94e")

_pushScopeId("data-v-58a8f94e")
const _hoisted_1 = { id: "app" }
const _hoisted_2 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("p", { class: "author" }, [
  /*#__PURE__*/_createTextVNode("Made with ❤ by "),
  /*#__PURE__*/_createVNode("a", {
    href: "https://twitter.com/pucherico",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "Puche")
], -1)
const _hoisted_4 = {
  key: 0,
  style: {"display":"inline"}
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { style: {"display":"inline"} }
const _hoisted_7 = /*#__PURE__*/_createTextVNode()
const _hoisted_8 = {
  key: 2,
  style: {"display":"inline"}
}
const _hoisted_9 = /*#__PURE__*/_createTextVNode()
const _hoisted_10 = { key: 3 }
const _hoisted_11 = { style: {"display":"inline"} }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { style: {"display":"inline"} }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_18 = {
  key: 1,
  class: "info-fps"
}
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Layer = _resolveComponent("Layer")
  const _component_Star = _resolveComponent("Star")
  const _component_LayerOverlay = _resolveComponent("LayerOverlay")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("button", {
      onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.hide(...args)))
    }, _toDisplayString(_ctx.hidden ? 'Show' : 'Hide'), 1),
    _hoisted_2,
    (!_ctx.hidden)
      ? _createVNode(_component_LayerOverlay, {
          key: 0,
          fullscreen: true
        }, {
          default: _withId(() => [
            _createVNode(_component_Layer, {
              class: "bottom-info",
              zIndex: 2
            }, {
              default: _withId(() => [
                _hoisted_3,
                (_ctx.inputEnabled)
                  ? (_openBlock(), _createBlock("div", _hoisted_4, [
                      _createVNode("p", null, [
                        _createVNode("a", {
                          onClick: _cache[2] || (_cache[2] = (...args) => (_ctx.disableInput(...args)))
                        }, "Disable input")
                      ])
                    ]))
                  : (_openBlock(), _createBlock("p", _hoisted_5, [
                      _createVNode("a", {
                        onClick: _cache[3] || (_cache[3] = (...args) => (_ctx.enableInput(...args)))
                      }, "Enable input")
                    ])),
                _createVNode("div", _hoisted_6, [
                  _createVNode("p", null, [
                    _createVNode("a", {
                      onClick: _cache[4] || (_cache[4] = (...args) => (_ctx.slower(...args)))
                    }, "➖"),
                    _hoisted_7,
                    _createVNode("a", {
                      onClick: _cache[5] || (_cache[5] = (...args) => (_ctx.quicker(...args)))
                    }, "➕")
                  ])
                ]),
                (_ctx.active)
                  ? (_openBlock(), _createBlock("div", _hoisted_8, [
                      _createVNode("p", null, [
                        _createVNode("a", {
                          onClick: _cache[6] || (_cache[6] = (...args) => (_ctx.pause(...args)))
                        }, "⏸Pause"),
                        _hoisted_9,
                        _createVNode("a", {
                          onClick: _cache[7] || (_cache[7] = (...args) => (_ctx.sleep(...args)))
                        }, "💤Sleep")
                      ])
                    ]))
                  : (_openBlock(), _createBlock("p", _hoisted_10, [
                      _createVNode("a", {
                        onClick: _cache[8] || (_cache[8] = (...args) => (_ctx.resume(...args)))
                      }, "▶Resume")
                    ])),
                _createVNode("p", null, "FPS: " + _toDisplayString(_ctx.fpsCount), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Layer, {
              zIndex: 3,
              class: "content"
            }, {
              default: _withId(() => [
                _createVNode("div", _hoisted_11, [
                  (!_ctx.backgroundLayerEnabled || !_ctx.backgroundLayerEnabled())
                    ? (_openBlock(), _createBlock("p", _hoisted_12, [
                        _createVNode("a", {
                          onClick: _cache[9] || (_cache[9] = (...args) => (_ctx.enableBackgroundLayer(...args)))
                        }, "Enable background")
                      ]))
                    : (_openBlock(), _createBlock("p", _hoisted_13, [
                        _createVNode("a", {
                          onClick: _cache[10] || (_cache[10] = (...args) => (_ctx.disableBackgroundLayer(...args)))
                        }, "Disable background")
                      ]))
                ]),
                _createVNode("div", _hoisted_14, [
                  (!_ctx.mainLayerEnabled || !_ctx.mainLayerEnabled())
                    ? (_openBlock(), _createBlock("p", _hoisted_15, [
                        _createVNode("a", {
                          onClick: _cache[11] || (_cache[11] = (...args) => (_ctx.enableMainLayer(...args)))
                        }, "Enable main Layer")
                      ]))
                    : (_openBlock(), _createBlock("p", _hoisted_16, [
                        _createVNode("a", {
                          onClick: _cache[12] || (_cache[12] = (...args) => (_ctx.disableMainLayer(...args)))
                        }, "Disable main Layer")
                      ]))
                ])
              ]),
              _: 1
            }),
            (!_ctx.hidden)
              ? _createVNode(_component_Star, {
                  key: 0,
                  ref: "star",
                  fullcanvas: true,
                  points: 5,
                  radius: 50,
                  spin: "",
                  elastic: "",
                  xalign: 0.5,
                  yalign: 0.5,
                  "onFrames-per-second": _cache[13] || (_cache[13] = $event => (_ctx.framesPerSecond$ = $event)),
                  "onCanvas-dimension": _cache[14] || (_cache[14] = $event => (_ctx.onCanvasDimension($event)))
                }, null, 512)
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      : _createCommentVNode("", true),
    _hoisted_17,
    (!_ctx.hidden)
      ? (_openBlock(), _createBlock("pre", _hoisted_18, "Frames per second: " + _toDisplayString(_ctx.fpsCount), 1))
      : _createCommentVNode("", true)
  ]))
})